import { render } from "./fertiController.vue?vue&type=template&id=60931180&scoped=true"
import script from "./fertiController.vue?vue&type=script&lang=js"
export * from "./fertiController.vue?vue&type=script&lang=js"

import "./fertiController.vue?vue&type=style&index=0&id=60931180&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60931180"]])

export default __exports__